import { useTranslation } from 'react-i18next';
import { PageHeading, PageSubHeading } from '@/typography/Typography';
import { ViewSwitch } from '@/components/shared/ViewSwitch';
import { TipsListPage } from './TipsListPage';
import { useMemo, useState } from 'react';
import { TipsEmployeeList } from './TipsEmployeeList';
import { TipsEmployeeListPage } from './TipsEmployeeListPage';
import { TipsReconciliationPage } from './TipsReconciliationPage';
import { useTipsHistory } from '@/services/paymentsQuery';

export const TipsAccountsPage = () => {
    const { t } = useTranslation();
    const [tabIndex, setTabIndex] = useState<number | null>(null);
    const { data: tipsHistoryData } = useTipsHistory(0, 16, []);

    const viewSwitchItems = useMemo(() => {
        let list = [
            {
                primaryText: t('daily_settlement'),
                badgeText: tipsHistoryData?.data?.total?.toString() ?? '',
                route: 'tips-settlement/page/0',
                path: 'tips-settlement/page/:pageNumber',
                overrideTestPath: 'tips-settlement/page',
                routeComponent: <TipsListPage />
            },
            {
                primaryText: t('reconciliation'),
                badgeText: '',
                route: 'tips-reconciliation',
                routeComponent: <TipsReconciliationPage />
            }
        ];
        return list;
    }, [tipsHistoryData?.data?.total]);

    return (
        <div>
            <PageHeading>{t('InstaTips')}</PageHeading>
            <PageSubHeading>{t('tips.tips_page_subtitle')}</PageSubHeading>
            <ViewSwitch
                itemList={viewSwitchItems}
                setSelectedIndex={setTabIndex}
                selectedIndex={tabIndex}
            />
        </div>
    );
};
